import React, { useRef } from "react";
import { observer } from "mobx-react";
import { Grid, Box } from "@mui/material";
import { FormToolbox } from "../../../../common/controls/forms/FormToolbox";
import { useReactToPrint } from "react-to-print";

import { EditionDocumentationView as SnapshotEditionDocumentationView } from "../snapshot/EditionDocumentationView";

export type SignedContractViewFormProps = {
  onPrint?: (handlePrint: () => void) => void;
  onCancel?: () => void;
  onEdit?: () => void;
  showToolbox?: boolean;
  recordId?: string;
  data_Value?: { displayId: string; id: string } | null;
  data_: string;
};

export const SignedContractViewForm: React.FC<SignedContractViewFormProps> =
  observer(
    ({
      onPrint = () => {},
      onCancel = () => {},
      onEdit,
      showToolbox = true,
      recordId,
      data_ = "{}",
    }) => {
      const componentRef = useRef(null);
      const handlePrint = useReactToPrint({
        content: () => componentRef.current,
      });

      return (
        <Grid>
          {showToolbox && (
            <FormToolbox
              editForm={onEdit}
              printForm={() => onPrint(handlePrint)}
              closeForm={() => onCancel()}
            />
          )}
          <Box ref={componentRef}>
            <SnapshotEditionDocumentationView
              snapshotData={data_ as any}
              snapshotEntityName="SignedContract"
              snapshotRecordId={recordId}
            />
          </Box>
        </Grid>
      );
    }
  );
